import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { Row } from 'antd';

import CreateBankAccountStepper from 'v2/components/Shared/CreateBankAccountStepper';
import GlobalLoading from 'v2/components/Shared/GlobalLoading';
import UnloggedLayout from 'v2/components/Shared/UnloggedLayout';
import useRequest from 'v2/hooks/useRequest';
import type { INewAccount } from 'v2/interfaces/financial';
import bankAccountForRefundsService from 'v2/services/refundAccount';

import AccountCreated from './AccountCreated';
import TokenExpired from './TokenExpired';

const BankAccountForRefund = () => {
  const qs = new URLSearchParams(window.location.search);
  const token = qs.get('token');
  const internacional = Boolean(qs.get('internacional'));

  const [isTokenValid, isLoading, tokenError] = useRequest(() => bankAccountForRefundsService.validateToken(token), []);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [banks, isLoadingBanks] = useRequest(
    () => bankAccountForRefundsService.getBanks(isTokenValid, internacional),
    [isTokenValid]
  );
  const [operations, isLoadingOperations] = useRequest(
    () => bankAccountForRefundsService.getOperations(isTokenValid),
    [isTokenValid]
  );

  const handleSubmit = async (account: INewAccount) => {
    try {
      await bankAccountForRefundsService.createAccount(account);
      toast.success('Solicitação enviada com sucesso!');
      setIsSubmitted(true);
    } catch (err) {
      console.error(err);

      if (err?.response?.status === 401) {
        toast.error('Este link está expirado, requisite um novo.');
        return;
      }

      toast.error('Algo de errado aconteceu, tente novamente em instantes!');
    }
  };

  if (isLoading) return <GlobalLoading />;
  if (tokenError || !isTokenValid) return <TokenExpired />;
  if (isSubmitted) return <AccountCreated />;

  return (
    <UnloggedLayout>
      <Row align='middle' justify='center'>
        <div className='border-border w-[80vw] max-w-[900px] rounded-sm border bg-white p-8'>
          <h4 className='text-text-heading text-2xl font-bold'>Cadastro de conta bancária</h4>
          <CreateBankAccountStepper
            banks={banks}
            operations={operations}
            isLoadingBanks={isLoadingBanks}
            isLoadingOperations={isLoadingOperations}
            isForeign={internacional}
            hasVideo={false}
            onSubmit={handleSubmit}
          />
        </div>
      </Row>
    </UnloggedLayout>
  );
};

export default BankAccountForRefund;
